goog.provide("shadow.js.shim.module$$mui$material$Collapse$default");
shadow.js.shim.module$$mui$material$Collapse$default = shadow.js.shim.module$$mui$material$Collapse.default;
